import { useEffect, useState } from "react";

import { VscArrowLeft, VscArrowRight } from "react-icons/vsc";
import { Fade } from "@mui/material";

import LeaveCard from "components/Screens/Timeoff/ManageTimeoff/Customer/LeaveCard";

function PendingRequests({ pendingLeaveRequests, fetchEmployeePendingLeaves, leaveBreakdown }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardShownOnScreenFlag, setCardShownOnScreenFlag] = useState(true);

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNextClick = () => {
    if (currentIndex < pendingLeaveRequests.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const runAnimationForLeaveCard = () => {
    setCardShownOnScreenFlag(false);
    setTimeout(() => setCardShownOnScreenFlag(true), 300);
  };

  useEffect(() => {
    runAnimationForLeaveCard();
  }, [currentIndex]);

  return (
    <div className="pending-leaves-container-customer p-1">
      <div className="flex w-full items-center justify-between">
        <div>
          <p className="heading-h5-semibold">
            Pending Requests
            {pendingLeaveRequests?.length ? `  (${currentIndex + 1}/${pendingLeaveRequests?.length})` : null}
          </p>
        </div>
        {pendingLeaveRequests?.length ? (
          <div>
            <VscArrowLeft
              onClick={handlePrevClick}
              className={`text-2xl cursor-pointer arrow-size mr-gap bg-primary-95 primary-30 ${
                currentIndex === 0 ? "blurred-arrow" : ""
              }`}
            />
            <VscArrowRight
              onClick={handleNextClick}
              className={`text-2xl cursor-pointer arrow-size bg-primary-95 primary-30 ${
                currentIndex === pendingLeaveRequests?.length - 1 ? "blurred-arrow" : ""
              }`}
            />
          </div>
        ) : null}
      </div>
      <Fade className="w-100p" in={cardShownOnScreenFlag}>
        {pendingLeaveRequests?.length ? (
          <div>
            <LeaveCard
              data={pendingLeaveRequests?.[currentIndex]}
              fetchEmployeePendingLeaves={fetchEmployeePendingLeaves}
              showProfileSection={false}
              runAnimationForLeaveCard={runAnimationForLeaveCard}
              leaveBreakdown={leaveBreakdown}
            />
          </div>
        ) : (
          <p className="text-center" style={{ display: "flex", justifyContent: "center" }}>
            No data available
          </p>
        )}
      </Fade>
      <div className="dots-container">
        {pendingLeaveRequests?.map((_, index) => (
          <span className={`dot ${index === currentIndex ? "active-dot" : "inactive-dot"}`} />
        ))}
      </div>
    </div>
  );
}

export default PendingRequests;
